<template lang="html">
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="1100"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        color="info" 
        v-on="on"
      >
        Edit
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      title="State Department Access"
      color="green"
      text="Change State Department Access"
      class="mb-0"
    >
      <v-form v-if="!loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="searchState"
                label="Search State"
                prepend-icon="mdi-flag"
              />
            </v-col>
          </v-row>
          <v-row
            class="overflow"
            data-simplebar
          >
            <v-col class="pt-0">
              <v-data-iterator
                :items="filteredStateDepartments"
                :hide-default-footer="true"
                disable-pagination
                item-key="name"
              >
                <template v-slot:default="{ items }">
                  <v-row>
                    <v-col
                      v-for="item in items"
                      :key="item.name"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                    >
                      <v-card>
                        <v-card-title class="py-0 ma-0">
                          <v-switch
                            v-model="item.is_active"
                            :label="item.name"
                            text-lg-center
                            @change="openStateTab(item)"
                          />
                        </v-card-title>

                        <v-divider />
                        <v-list
                          v-if="item.is_active"
                          dense
                        >
                          <v-list-item
                            v-for="department in item.departments"
                            :key="department.id"
                          >
                            <v-list-item-content class="py-0">
                              {{ department.name }}
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-checkbox v-model="department.is_active" />
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>

  export default {
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      noOfStates: {
        type: Number,
        required: true,
      },
    },
    data: () => ({
      dialog: null,
      loading: false,
      progressing: false,
      stateDepartments: [],
      finalData: [],
      searchState: '',

    }),
    computed: {
      filteredStateDepartments () {
        let _this = this
        let stateDepartments = [...this.stateDepartments]

        if (this.searchState) {                    
          stateDepartments = stateDepartments.filter(function (state) {
            return state.name.toLowerCase().indexOf(_this.searchState.toLowerCase()) !== -1
          })
        } 
        
        return stateDepartments
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          if (this.noOfStates > 0) {
            this.loadExistingStateDepartments()
          } else {
            this.loadData()
          }
        }
      },    
    },
    methods: { 
      openStateTab (item) {
        this.stateDepartments.map(stateDepartment => {
          if (item.id === stateDepartment.id) {
            stateDepartment.departments = this.selectAllDepartments(stateDepartment.is_active, stateDepartment.departments)
          }
        })
      },

      selectAllDepartments (isActive, departments) {
        departments.map(department => {
          if (isActive) {
            department.is_active = true
          } else {
            department.is_active = false
          }
        })
        return departments
      },

      loadExistingStateDepartments () {
        let stateDepartments = []

        this.loading = true

        Promise.all([
          this.$api.states().list(),
          this.$api.departments().list(['name'], false),
          this.$api.adminStates().list(this.employeeUid),
        ])
          .then(([states, departments, adminStates]) => {
            let groupedAdminStateDepartments = _(adminStates.data).groupBy('state_id')
              .map((items, stateName) => {
                return {
                  state: parseInt(stateName),
                  departments: _.map(items, 'department.id'),
                }
              }).value()

            states.data.map(state => {
              stateDepartments.push({
                'id': state.id,
                'name': state.name,
                'is_active': false,
                'departments': this.formatDepartments(state.id, JSON.parse(JSON.stringify(departments.data)), null),
              }) 
            })

            stateDepartments.map(stateDepartment => {
              groupedAdminStateDepartments.map(adminState => {
                if (stateDepartment.id === adminState.state) {
                  stateDepartment.is_active = true
                  stateDepartment.departments = this.formatDepartments(stateDepartment.id, JSON.parse(JSON.stringify(departments.data)), adminState.departments)
                } 
              })
            })

            this.stateDepartments = stateDepartments
            this.loading = false
          })
      },

      loadData () {
        let stateDepartments = []

        this.loading = true

        Promise.all([
          this.$api.states().list(),
          this.$api.departments().list(['name'], false),
        ])
          .then(([states, departments]) => {
            states.data.map(state => {
              stateDepartments.push({
                'id': state.id,
                'name': state.name,
                'is_active': false,
                'departments': this.formatDepartments(state.id, JSON.parse(JSON.stringify(departments.data)), null),
              })
            })
            
            this.stateDepartments = stateDepartments
            this.loading = false
          })
      },
      formatDepartments (id, departments, assignedDepartments) {
        let updatedDepartments = []

        if (assignedDepartments) {
          departments.map(department => {
            updatedDepartments.push({
              'id': department.id + '-' + id,
              'name': department.name,
              'is_active': !!assignedDepartments.includes(department.id),
            })
          })
        } else {
          departments.map(department => {
            updatedDepartments.push({
              'id': department.id + '-' + id,
              'name': department.name,
            })
          })
        }
  
        return updatedDepartments
      },
      prepareFormData () {
        this.finalData = []
  
        this.stateDepartments.map(state => {
          this.finalData.push({
            'states': state.id,
            'departments': this.getDepartmentIds(state.departments),
          })
        })
     
        this.finalData = this.finalData.filter(item => {
          return item.departments.length > 0
        })
    
        return this.finalData
      },
      submitForm () {
        this.progressing = true
        this.$api.adminStates().update(this.employeeUid, this.prepareFormData())
          .then(response => {
            if (response.status === 200) {
              this.$emit('created')
              this.$snack({
                message: response.data.status,
              })
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
            this.dialog = false
          })
      },

      getDepartmentIds (departments) {
        let data = []

        departments.map(department => {
          if (department.is_active) {
            data.push(department.id.substring(0, department.id.indexOf('-')))
          }
        })

        return data
      },

    },
  }
</script>

<style lang="css" scoped>
.overflow {
  overflow-y: scroll; 
  height: 50vh;
}

::-webkit-scrollbar {
  width: 0px;  /* Remove scrollbar space */
  background: transparent;  /* Optional: just make scrollbar invisible */
}
</style>
